import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSelect, CustomSelectProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomSelectWrapperProps = WithInput<CustomSelectProps>;

const CustomSelectWrapper: React.FC<CustomSelectWrapperProps> = (props: CustomSelectWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomSelect
            containerStyle={containerStyle}
            filterOption={(text, option) => option?.title && option.title.toLowerCase().includes(text.toLowerCase())}
            getContainerRef={setContainerRef}
            showSearch
            allowClear
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomSelectWrapper);
